import React, { useEffect, useState } from 'react';
import { Modal, Space, Tooltip } from 'antd';
import { SpanButton } from 'component/button_components/button.style';
import TableComponent from 'component/table_component/antTable/table';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import { ReactComponent as DeleteIcon } from 'assets/images/SVG/icons/delete-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { deleteEndpoint, getEndpoints, getSingleEndPoint } from 'redux/slices/endpointsSlice';
import { AdminPageSizeWrap, AdminPageWrap, AdminTitleWrap } from 'pages/admin_page/style';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import CreateEndpoint from 'component/modal_components/endpoint/create_endpoint';
import UpdateEndPoint from 'component/modal_components/endpoint/update_endpoint';
import Swal from 'sweetalert2';
import { SweetSweetAlert } from 'component/sweetalert_components';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import TableLoader from 'component/loader_component/tableLoader';
import { FigCaption } from 'pages/license/style';
import { refreshToken } from 'redux/slices/authSlice';

export default function Endpoints() {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [checkAction, setCheckAction] = useState(false);
  const [recordData, setRecordData] = useState(null);
  const { endpointData, loading } = useSelector((state) => state.endpoints);

  useEffect(() => {
    dispatch(getEndpoints());
  }, []);

  const columns = [
    {
      title: 'Protocol',
      dataIndex: 'protocol',
    },
    {
      title: 'Domain',
      dataIndex: 'domain',
    },
    {
      title: 'Port',
      dataIndex: 'port',
    },
    {
      title: 'Endpoint',
      dataIndex: 'endpoints',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      render: (_, record) => (
        <Space className='af-superadmin-domain-space-wrap'>
          <Tooltip title='Update' color='#597081' className='af-superadmin-endpoint-edit-tooltip'>
            <SpanButton className='af-superadmin-endpoint-edit-tooltip-button' onClick={() => handleEditClick(record)}>
              <EditIcon className='af-superadmin-endpoint-edit-tooltip-icon' />
            </SpanButton>
          </Tooltip>
          {record.id !== 1 && (
            <Tooltip title='Delete' color='#597081' className='af-superadmin-endpoint-delete-tooltip'>
              <SpanButton
                className='af-superadmin-endpoint-delete-tooltip-button'
                onClick={() => handleDeleteClick(record)}
              >
                <DeleteIcon className='af-superadmin-endpoint-delete-tooltip-icon' />
              </SpanButton>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const handleCreate = () => {
    setModal(true);
    setCheckAction(false);
    dispatch(refreshToken());
  };

  const handleEditClick = async (record) => {
    setCheckAction(true);
    try {
      setEditLoader(true);
      const getSingleValue = await dispatch(getSingleEndPoint(record.id));
      if (getSingleValue?.payload.status === 200) {
        setModal(true);
        setRecordData(getSingleValue.payload.data);
      }
    } catch (err) {
      return err;
    } finally {
      setEditLoader(false);
    }
  };

  const handleDeleteClick = async (record) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Are you sure you want to delete?',
      showConfirmButton: true,
      confirmButtonColor: 'var(--bg-button-default-color)',
      width: '400px',
      heightAuto: false,
      showCancelButton: true,
      cancelButtonColor: 'green',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        container: 'custom-swal-container',
        icon: 'custom-swal-icon',
        title: 'custom-swal-title',
      },
    });

    if (result.isConfirmed) {
      try {
        const sweetAlert = await dispatch(deleteEndpoint(record.id));
        if (sweetAlert.payload && sweetAlert.payload.status === 200) {
          SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
          dispatch(getEndpoints());
        } else {
          SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      } catch (error) {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    }
  };

  return (
    <AdminPageWrap className='af-superadmin-endpoint-wrap'>
      <AdminPageSizeWrap className='af-superadmin-endpoint-content'>
        <BackButton className='af-superadmin-endpoint-backbutton' to='/'>
          <LeftArrowIcon className='af-superadmin-endpoint-leftarrow' /> Back
        </BackButton>
        <AdminTitleWrap className='af-superadmin-endpoint-title-wrap'>
          <h2 className='af-superadmin-endpoint-title-head'>Endpoints</h2>
          <div className='af-superadmin-endpoint-title-caption-wrap'>
            <FigCaption className='af-superadmin-endpoint-title-caption'>
              **Generally you don't need to do anything here if you are running AD Web behind a reverse proxy.
            </FigCaption>
          </div>
          <div className='af-superadmin-endpoint-title-button-wrap'>
            <StyledButton type='primary' onClick={handleCreate} className='af-superadmin-endpoint-title-button'>
              Add Endpoint
            </StyledButton>
          </div>
        </AdminTitleWrap>
        <div className='af-superadmin-endpoint-table-wrap'>
          <TableComponent
            loading={{
              spinning: loading,
              indicator: <TableLoader />,
            }}
            columns={columns}
            data={endpointData && endpointData}
          />
        </div>
      </AdminPageSizeWrap>
      {editLoader && <ModalOpenLoader />}
      {modal && (
        <Modal
          className='af-superadmin-endpoint-modal'
          open={modal}
          maskClosable={false}
          footer={[null]}
          onCancel={() => setModal(false)}
          centered
        >
          {checkAction ? (
            <UpdateEndPoint setModal={setModal} recordData={recordData} />
          ) : (
            <CreateEndpoint setModal={setModal} />
          )}
        </Modal>
      )}
    </AdminPageWrap>
  );
}
